export function remove(key: string) {
	localStorage.removeItem(key);
}

export function set(key: string, value: string) {
	localStorage.setItem(key, value);
}

export function get(key: string) {
	return localStorage.getItem(key);
}

export function setJSON(key: string, value: any) {
	set(key, JSON.stringify(value));
}

export function getJSON(key: string) {
	const value = get(key);

	if (value !== null) {
		try {
			return JSON.parse(value);
		} catch (e) {
			remove(key);
		}
	}

	return;
}

export function setJSONArray(key: string, value: any[]) {
	setJSON(key, value);
}

export function getJSONArray(key: string): any[] {
	return getJSON(key) || [];
}

export function clear() {
	localStorage.clear();
}
